import Header from "./components/Header";
import SearchHero from "./components/SearchHero";
import FlashTimeline from "./components/FlashTimeline";
import ArchiveSection from "./components/ArchiveSection";
import HotRank from "./components/HotRank";
import Discussion from "./components/Discussion";
import InfoSection from "./components/InfoSection";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-background-50">
      <Header />
      <main>
        <SearchHero />
        <FlashTimeline />
        <ArchiveSection />
        <HotRank />
        <Discussion />
        <InfoSection />
      </main>
      <Footer />
    </div>
  );
}